export default __webpack_public_path__ + "static/media/banner3.186389b1.png";